import { jsx as u } from "react/jsx-runtime";
import "@smart/web-foundations";
import { c as j } from "./chunks/index.rKuIKazb.js";
import w from "react";
import './assets/spacer.css';const _ = {
  "width-0": "_width-0_1uzgj_3",
  "width-50": "_width-50_1uzgj_6",
  "width-100": "_width-100_1uzgj_9",
  "width-200": "_width-200_1uzgj_12",
  "width-300": "_width-300_1uzgj_15",
  "width-400": "_width-400_1uzgj_18",
  "width-500": "_width-500_1uzgj_21",
  "width-600": "_width-600_1uzgj_24",
  "width-700": "_width-700_1uzgj_27",
  "width-800": "_width-800_1uzgj_30",
  "width-900": "_width-900_1uzgj_33",
  "width-1000": "_width-1000_1uzgj_36",
  "height-0": "_height-0_1uzgj_39",
  "height-50": "_height-50_1uzgj_42",
  "height-100": "_height-100_1uzgj_45",
  "height-200": "_height-200_1uzgj_48",
  "height-300": "_height-300_1uzgj_51",
  "height-400": "_height-400_1uzgj_54",
  "height-500": "_height-500_1uzgj_57",
  "height-600": "_height-600_1uzgj_60",
  "height-700": "_height-700_1uzgj_63",
  "height-800": "_height-800_1uzgj_66",
  "height-900": "_height-900_1uzgj_69",
  "height-1000": "_height-1000_1uzgj_72"
}, z = w.forwardRef(
  ({ height: h = 0, width: t = 0, className: i, ...g }, e) => {
    const d = j(
      _.spacer,
      {
        [_[`width-${t}`]]: t,
        [_[`height-${h}`]]: h
      },
      i
    );
    return /* @__PURE__ */ u("div", { className: d, ...g, ref: e });
  }
);
z.displayName = "Spacer";
export {
  z as Spacer
};
//# sourceMappingURL=spacer.js.map
